<template>
  <atoms-card
    class="keypoints"
    v-bind="component.card"
  >
    <!-- eslint-disable vue/no-v-html -->
    <p
      class="text-xl font-bold mb-4"
      v-html="props.title"
    >
    </p>
    <!-- eslint-enable vue/no-v-html -->

    <slot />

    <!-- eslint-disable vue/no-v-html -->
    <div
      v-if="props.document"
      v-html="documentToHtmlString(props.document)"
    >
    </div>
    <!-- eslint-enable vue/no-v-html -->
  </atoms-card>
</template>

<script setup>
defineOptions({
  name: 'MoleculesKeyPoints'
})

const props = defineProps({
  title: {
    type: String,
    default: 'Key Points'
  },

  items: {
    type: Array,
    default: () => []
  },

  document: {
    type: Object,
    default: null
  },

  theme: {
    type: String,
    default: 'default',
    validator: value => ['default', 'border-left-primary', 'gray-boxed'].includes(value)
  }
})

const component = computed(() => {
  const border = (() => {
    const disc = getKey(props.theme, {
      default: '[&_ul_li]:before:bg-semantic-primary-default',
      'border-left-semantic-primary-default,gray-boxed': '[&_ul_li]:before:bg-dark'
    })

    return `${disc} [&_ul_li]:before:inline-block [&_ul_li]:before:mr-4 [&_ul_li]:before:relative [&_ul_li]:before:top-2 [&_ul_li]:before:rounded-full`
  })()

  const card = getKey(props.theme, {
    default: {
      class: border
    },

    'border-left-primary': {
      theme: 'plain',
      shadow: 'none',
      size: 'none',
      rounded: 'none',
      class: `lg:py-6 lg:px-8 lg:bg-gray-10 lg:border-l-4 lg:border-l-semantic-primary-default ${border}`
    },

    'gray-boxed': {
      theme: 'bordered',
      shadow: 'none',
      class: `bg-gray-10 ${border}`
    }
  })

  return {
    card
  }
})
</script>
<style>
.keypoints ul {
  @apply pl-1;
}

.keypoints ul li {
  @apply relative flex mb-4;
}

.keypoints ul li:before {
  content: "";
  width: 8px;
  height: 8px;
  flex: 0 0 8px;
}

.keypoints ul li > * {
  margin: 0;
}
</style>